<h1 mat-dialog-title><i [class]="icon" (click)="openSecret()"></i>&nbsp;&nbsp; {{ header }}</h1>
<div mat-dialog-content class="border-top border-bottom pt-3 pb-3">

<ng-content></ng-content>

</div>
<div mat-dialog-actions class="text-center">
    <div class="container-fluid px-0 py-3 justify-content-between" *ngIf="!overwriteToolbar; else customToolbar">
      <button class="btn btn-light text-danger mx-2" mat-dialog-close *ngIf="cancelButtonLabel">{{ cancelButtonLabel }}</button>
      <button class="btn btn-primary text-light mx-2" [disabled]="isConfirming" (click)="confirmPressed()" *ngIf="confirmButtonLabel">
        <i class="fa fa-spinner mr-3 rotate-constant" *ngIf="isConfirming"></i>{{ confirmButtonLabel }}
      </button>
    </div>
    <ng-template #customToolbar>
      <ng-content select="[toolbar]"></ng-content>
    </ng-template>
</div>
